import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="min-h-screen flex flex-col items-center justify-center px-4 py-16" data-id="element-76">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="max-w-4xl w-full text-center" data-id="element-77">
        {/* Hero Image */}
        <div className="mb-12 flex justify-center" data-id="element-78">
          <img src="https://cdn.magicpatterns.com/uploads/qNeCEMJardPFGYbBqwjr6U/2_-_4.png" alt="Avatar Digital Rentable - Kit de 7 días" className="max-w-md w-full h-auto" data-id="element-79" />
        </div>

        {/* Headline */}
        <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-80">
          No te falta carisma.{' '}
          <span className="text-cyan-400" data-id="element-81">Te falta un avatar consistente.</span>
        </h1>

        {/* Subheadline */}
        <p className="text-xl md:text-2xl text-gray-300 mb-12 leading-relaxed" data-id="element-82">
          Crea un avatar que vende sin mostrar tu cara (en 7 días).
        </p>

        {/* CTA */}
        <CTAButton href="#pricing" data-id="element-83">
          Consigue "Avatar Digital Rentable" hoy
        </CTAButton>

        {/* Opening Copy */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.5,
        duration: 0.6
      }} className="mt-16 text-left max-w-3xl mx-auto" data-id="element-84">
          <p className="text-lg text-gray-300 leading-relaxed" data-id="element-85">
            No estás fallando porque "no sirves para redes".
          </p>
          <p className="text-lg text-gray-300 leading-relaxed mt-4" data-id="element-86">
            Estás fallando porque cada vez que intentas contenido faceless… lo
            haces como si fuera un truco.
          </p>
          <p className="text-lg text-gray-300 leading-relaxed mt-4" data-id="element-87">
            Un día pruebas una voz. Al siguiente cambias el estilo. Luego
            cambias el tema. Después te da vergüenza, lo borras, y vuelves a
            empezar.
          </p>
        </motion.div>
      </motion.div>
    </section>;
}